module.exports = __webpack_public_path__ + "../fonts/slick.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/slick-carousel/slick/fonts/slick.svg
// module id = 281
// module chunks = 0 1